
<div class="container mt-8 pb-5">
    <div class="row justify-content-center">
      <div class="col-lg-5 col-md-7">
        <div class="card">
          <div class="card-body px-lg-5 py-lg-5">
            <div class="text-center text-muted mb-4">
              <img src="assets/img/brand/logo.png" style="max-width: 300px;" class="mb-4 w-100" />
              <h1>Réinitialiser votre mot de passe</h1>
            </div>
  
            <!-- login -->
            <form role="form" [formGroup]="FormResetPassword" (ngSubmit)="onSubmit()">
              <div class="form-group mb-3">
                <div class="input-group input-group-alternative">
                  <div class="input-group-prepend">
                    <span [ngClass]="{'icon-border-error':resetPassword.password.errors && submitForgotPassword}" class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
                  </div>
                  <input [ngClass]="{'input-border-error':resetPassword.password.errors && submitForgotPassword}" class="form-control" placeholder="Mot de passe" type="password" formControlName="password">
                </div>
              </div>
              <div class="form-group">
                <div class="input-group input-group-alternative">
                  <div class="input-group-prepend">
                    <span [ngClass]="{'icon-border-error':resetPassword.confirmPassword.errors && submitForgotPassword}" class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
                  </div>
                  <input [ngClass]="{'input-border-error':resetPassword.confirmPassword.errors && submitForgotPassword}" class="form-control" placeholder="Confirmation de mot de passe" type="password" formControlName="confirmPassword">
                </div>
              </div>
              <div class="text-center">
                <button type="submit" class="btn btn-studiomap my-4 w-100"><i class="fa fa-check mr-2"></i>Valider</button>
              </div>
            </form>

          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6 pointer"><a href="javascript:void(0)" (click)="navigateTo('login')"
              class="text-dark"><small>Connexion</small></a>
          </div>
          <div class="col-6 text-right pointer"><a href="javascript:void(0)" class="text-dark"
            (click)="navigateTo('register')"><small>Créer un nouveau compte</small></a>
            </div>
        </div>
      </div>
    </div>